import { action, computed, observable, makeObservable } from 'mobx';
import {logger} from '../../../lib/helpers';
import {HomeworkState} from '../homework-models';

export class HomeworkStateStore {
  @observable
  homeworkState: HomeworkState | null;

  constructor() {
    makeObservable(this);
    this.homeworkState = null;
  }

  @computed
  get currentPageId(): number | null {
    return this.homeworkState === null
      ? null
      : this.homeworkState.CurrentPageId;
  }

  @computed
  get currentPushableBlockId(): number | null {
    return this.homeworkState === null
      ? null
      : this.homeworkState.CurrentPushableBlockId;
  }

  @action
  updateHomeworkState = (homeworkState: HomeworkState) => {
    const next = homeworkState;
    // noinspection SuspiciousTypeOfGuard
    if (next === null ||
      next === undefined ||
      typeof next !== 'object' ||
      typeof next.Version !== 'number') {
      logger.error('HomeworkHubStore.updateState', 'unexpected value for state', next);
      return;
    }
    let current = this.homeworkState;
    if (current === null)
      this.homeworkState = next;
    else if (current.Version <= next.Version)
      this.homeworkState = next;
    else
      logger.log('HomeworkHubStore: stale version', 'current=', current, 'received=', next);
  };

  @action
  clearHomeworkState = () => {
    this.homeworkState = null;
  };
}

